module.exports = __webpack_public_path__ + "media/snacks/eats-no-snacks-cac5ce59.svg";